import { Box, Dialog, Heading, HStack, Portal, Text, useBreakpointValue } from '@chakra-ui/react';
import { MdClose } from 'react-icons/md';
import { RiftboundButton } from '../../../components/ui/button';
import {
  RiftboundBottomSheet,
  SHEET_Z_CARD,
} from '../../../components/ui/bottom-sheet';
import { PendingInvitesSection } from './TeamInviteList';

export interface JoinRequestsModalProps {
  open: boolean;
  onClose: () => void;
}

/** Account-menu modal: accept / decline pending team invites (shows who invited). */
export function JoinRequestsModal({ open, onClose }: JoinRequestsModalProps) {
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? false;

  const body = (
    <>
      <Text fontSize="sm" color="textMuted" mb={4}>
        Accept or decline invites. You&apos;ll see who invited you for each team.
      </Text>
      <PendingInvitesSection />
    </>
  );

  if (isMobile) {
    return (
      <RiftboundBottomSheet
        isOpen={open}
        onClose={onClose}
        zIndex={SHEET_Z_CARD}
        detent="content-height"
        disableDrag
        header={
          <Heading as="h2" size="sm" w="100%" textAlign="center" px={2}>
            Team invites
          </Heading>
        }
      >
        <Box px={4} pb={6}>
          {body}
        </Box>
      </RiftboundBottomSheet>
    );
  }

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(e) => {
        if (!e.open) onClose();
      }}
      placement="center"
    >
      <Portal>
        <Dialog.Backdrop bg="blackAlpha.700" style={{ backdropFilter: 'blur(4px)' }} />
        <Dialog.Positioner>
          <Dialog.Content
            bg="surface"
            color="text"
            borderWidth="hairline"
            borderColor="border"
            mx={4}
            maxW="480px"
            w="full"
          >
            <Dialog.Header>
              <HStack justify="space-between" w="full" align="center">
                <Dialog.Title asChild>
                  <Heading as="h2" fontSize="lg" fontWeight="semibold">
                    Team invites
                  </Heading>
                </Dialog.Title>
                <RiftboundButton
                  treatment="ghost"
                  size="sm"
                  p={1}
                  onClick={onClose}
                  aria-label="Close"
                >
                  <MdClose />
                </RiftboundButton>
              </HStack>
            </Dialog.Header>
            <Dialog.Body pb={5}>{body}</Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
